import React, {
	//useState,
	//useEffect,
	//useCallback,
} from 'react';

//import {
	//toDate,
	//zonedTimeToUtc,
	//utcToZonedTime,
	//format
//} from 'date-fns-tz';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Modal from 'react-bootstrap/Modal';
//import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import { AnimalAgeSelect } from 'components/animalAgeSelect.js';
//import { TimezoneSelect } from 'components/timezoneSelect.js';
//import { AnimalSizeSelect } from 'components/animalSizeSelect.js';
//import { AnimalGenderSelect } from 'components/animalGenderSelect.js';
//import { BreedTypeSelect } from 'components/breedTypeSelect.js';
//import GenericModal from 'components/genericModal.js';




export const PaddockSize = (props) => {
	const {
		cols,
		value,
		handleChange,
		controlStyle,
		lock,
		//required
	} = props
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	evt.target.setCustomValidity('Hectares as integer only eg. 5 or 23!');
	// 	//console.log('running handleValidate()', evt)
	// }

	return (
		<Row className="inputRow">
			<Col sm={ cols.lhs }>Paddock size [Ha]:</Col>
			<Col sm={ cols.rhs }>
				<Form.Control
					id = 'Paddock'
					placeholder="Enter paddock size..."
					onChange = {(evt) => handleChange(evt)}
					style = { controlStyle }
					value = { value }
					{ ...(lock && { disabled: true }) }
				/>
			</Col>
		</Row>
	)
}

export const SessionName = (props) => {
	// const handleValidate = (evt) =>{
	// 	console.log('running handleValidate()', evt)
	// }
	const {cols, value, handleChange, controlStyle, lock} = props
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	console.log('evt', evt)
	// 	console.log('evt.target.validity', evt.target.validity)
	// 	evt.target.setCustomValidity('Session name letters, numbers _ or - only.');
	// }
	//console.log('SessionName value:', value)
	return (
		<Row className="inputRow">
			<Col sm={ cols.lhs }>Session name:</Col>
			<Col sm={ cols.rhs }>
				<Form.Control
					id = 'SessionName'
					placeholder="Enter session name..."
					required = { true }
					onChange = {(evt) => handleChange(evt)}
					style = { controlStyle }
					value = { value }
					{ ...(lock && { disabled: true }) }
					//isInvalid = { true }
					//isInvalid = {(props.value === undefined)}
					//pattern = {'^[a-zA-Z]+[a-zA-Z0-9_ -]+$'}
					//title = 'Session name letters, numbers _ or - only.'
					//onInvalid = { handleInvalid }
					//isInvalid = {true}
				/>
				{/* <Form.Control.Feedback type='invalid'>
					Please enter a name for the session.
				</Form.Control.Feedback> */}
			</Col>
		</Row>
	)
}

export const HeadCount = (props) => {
	const { cols, value, handleChange, controlStyle, lock } = props
	// const handleInvalid = (evt) =>{
	// 	evt.persist()
	// 	evt.target.setCustomValidity('Numbers - integer only!');
	// 	//console.log('running handleValidate()', evt)
	// }
	return (
		<Row className="inputRow">
			<Col sm={ cols.lhs }>Number of head:</Col>
			<Col sm={ cols.rhs }>
				<Form.Control
					id = 'Head'
					placeholder="Enter head count..."
					onChange = {(evt) => handleChange(evt)}
					style = { controlStyle }
					value = { value }
					{ ...(lock && { disabled: true }) }
					//required
					//pattern = {'[0-9]+(.[0-9][0-9]?)?'}
					//pattern = {'^[0-9]*?'}
					//onInvalid = { handleInvalid }
					//title = 'Numbers - integer only!'
				/>
				<Form.Control.Feedback type="invalid">
				Please enter Head count
				</Form.Control.Feedback>
			</Col>
		</Row>
	)
}

export const ShowOpenSessionsOnly = (props) => {
	const {value, setShowOpenSessionsOnly, controlStyle} = props

	const handleChange = (evt) => {
		evt.persist()
		//console.log('evt.target.checked', evt.target.checked)
		setShowOpenSessionsOnly(evt.target.checked)
	}
	return (
				<Form.Check
					inline
					//label = 'Show open sessions only'
					label = 'Hide closed sessions'
					id = 'show-open-sessions-only'
					onChange = { handleChange }
					style = { controlStyle }
					value = { value }
					className='sessionListFilterCB'
				/>
	)
}

export const SessionEndDate = (props) => {
	const {cols, value, controlStyle, handleSessionEndObjChange, lock} = props;
	//const endDatef = (value === null || value === undefined)? 'n/a - still open': format(value, 'dd MMM yyyy HH:mm:ss', {});

	if (value === null || value === undefined){
		return ( null )
			// <Row>
	 		// 	<Col sm={ cols.lhs }>Session End:</Col>
 			// 	<Col sm={ cols.rhs }>
 			// 		<Form.Control
 			// 			style = { controlStyle }
 			// 			value = { 'n/a - still open' }
 			// 			disabled
 			// 		/>
 			// 	</Col>
			// </Row>
	} else {
		return (
			<Row className="inputRow">
			<Col sm={ cols.lhs }>Session end:</Col>
			<Col sm={ cols.rhs }>
				<DatePicker
					id = 'sessionEndObj'
					className = { 'datepickerxx form-control' }
					//className = { 'datepicker' }
					dateFormat = { "dd MMM yyyy HH:mm" }
					selected={ value || new Date() }
					showTimeSelect
					todayButton = { "Now" }
					timeIntervals = { 15 }
					scrollableYearDropdown = { true }
					showYearDropdown = { true }
					onChange={ (dateObj) => handleSessionEndObjChange(dateObj) }
					style = { controlStyle }
					{ ...(lock && { disabled: true }) }
				/>
			</Col>
			</Row>
		)
	}
}